import { Component, useEffect } from 'react';
import '@/App.css';
import Lenis from 'lenis';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Marquee } from '@/components/Marquee';
import { Features } from '@/components/Features';
import { VoiceTest } from '@/components/VoiceTest';
import { HowItWorks } from '@/components/HowItWorks';
import { Purchase } from '@/components/Purchase';
import { Faq } from '@/components/Faq';
import { Footer } from '@/components/Footer';

// Keeps one broken section from blanking the whole page.
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
}

const useLenis = () => {
    useEffect(() => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) return undefined;

        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf = requestAnimationFrame(function loop(time) {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        });

        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);
};

const Page = () => {
    useLenis();
    return (
        <div id="top" className="min-h-screen bg-ink text-foreground">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Features />
                <VoiceTest />
                <HowItWorks />
                <Purchase />
                <Faq />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <ErrorBoundary>
            <Page />
        </ErrorBoundary>
    );
}

export default App;
